import React from 'react';

const FigmaIcon = () => {
  return <img src='/skill-icons/figma.png' alt='figma-logo' />;
};

export default FigmaIcon;
